import { render, staticRenderFns } from "./InputPlace.vue?vue&type=template&id=015d7d60"
import script from "./InputPlace.vue?vue&type=script&lang=js"
export * from "./InputPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports